import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

const toast = Object.assign(
  (...args) => sonnerToast(...args),
  {
    ...sonnerToast,
    error: (message, opts = {}) => sonnerToast.error(message, { duration: 6000, ...opts }),
    success: (message, opts = {}) => sonnerToast.success(message, { duration: 4000, ...opts }),
    dismissAll: () => sonnerToast.dismiss(),
  }
);

export { Toaster, toast }
